import { BitePlatform } from '@biteinc/enums';

import { GCNAlertView } from '~/app/js/views/gcn_alert_view';

const missingStoredValueIntegrationMessage =
  'No matching stored value integration found for this system.';

function getErrorMessage(error: unknown): string | undefined {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'object' && error && 'message' in error) {
    const message = error.message;
    return typeof message === 'string' ? message : undefined;
  }

  return undefined;
}

export function showStoredValueIntegrationRefreshPromptIfNeeded(error: unknown): boolean {
  const message = getErrorMessage(error);
  if (
    message !== missingStoredValueIntegrationMessage ||
    !window.isFlash ||
    window.platform !== BitePlatform.Flash
  ) {
    return false;
  }

  gcn.menuView.dismissSpinner();
  gcn.menuView.dismissStablePopup();
  gcn.menuView.showModalPopup(
    new GCNAlertView({
      text: 'This checkout is using an older gift card setup. Refresh checkout to continue with the latest campus card settings.',
      okText: 'Refresh Checkout',
      okCallback: () => {
        window.location.reload();
      },
    }),
  );

  return true;
}
